export type THideSocials = {
	FACEBOOK: boolean
	GOOGLE: boolean
	APPLE: boolean
}

export const env = {
	BUILD_VERSION: process.env.APP_BUILD_VERSION as string,
	BASE_URL: process.env.REACT_APP_API_URL as string,
	API_URL: (process.env.REACT_APP_API_URL + '/api-v1') as string,
	INTERNAL_API_URL: ((process.env.REACT_APP_INTERNAL_API_URL ||
		process.env.REACT_APP_API_URL) + '/api-v1') as string,
	MOBI_URL: process.env.REACT_APP_BASE_MOBI_URL as string,
	HOST: process.env.NEXT_PUBLIC_HOST as string,
	GTM_ID: process.env.NEXT_PUBLIC_GTM as string,
	LOCALE_LIST: (process.env.NEXT_ALLOWED_LOCALIZATION || 'en').split(','),
	// SSR/middleware-only, read at request time (MYQRCODE-10798)
	ALLOW_AUTOMATED_LANGUAGE_DETECTION:
		process.env.NEXT_ALLOW_AUTOMATED_LANGUAGE_DETECTION === 'true',
	TRANSLATIONS_CACHE_TTL: process.env.CACHE_TRANSLATIONS_TTL_SEC as string,
	ENV: process.env.NODE_ENV as string,
	// 	Auth
	APPLE_OAUTH_CLIENT_ID: process.env
		.NEXT_PUBLIC_APPLE_OAUTH_CLIENT_ID as string,
	GOOGLE_AUTH_CLIENT_ID: process.env
		.REACT_APP_GOOGLE_AUTH_CLIENT_ID as string,
	FACEBOOK_APP_ID:
		(process.env.REACT_APP_FACEBOOK_APP_ID as string) || '852634732394583',
	HIDE_SOCIALS: {
		FACEBOOK: process.env.HIDE_SOCIALS_FACEBOOK === 'true',
		GOOGLE: process.env.HIDE_SOCIALS_GOOGLE === 'true',
		APPLE: process.env.HIDE_SOCIALS_APPLE === 'true',
	} satisfies THideSocials,
	HIDE_SIGN_UP_PASSWORD: process.env.HIDE_SIGN_UP_PASSWORD === 'true',
	// Captcha
	TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY as string,
	// Payment
	STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
	// Analytics
	POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY as string,
	POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST as string,
	// Server-only analytics vars, read at request time by apiRoutes handlers
	PLAUSIBLE_DATA_DOMAIN: process.env.PLAUSIBLE_DATA_DOMAIN,
	PLAUSIBLE_TEST_LOCAL: Boolean(process.env.PLAUSIBLE_TEST_LOCAL),
	// Same var Sentry's `environment` field already uses — no new deploy config needed.
	ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT || 'development',
	// Server-only (kept out of next.config.js's `env` block) — the PMS host
	// for server-side calls; client-side uses the same-origin rewrite instead.
	PAYMENTS_API_URL: process.env.PAYMENTS_API_URL as string,
	ENABLE_AXIOS_LOGS_ON_SERVER:
		process.env.ENABLE_AXIOS_LOGS_ON_SERVER === 'true',
	JWT_REFRESH_TOKEN_SERVER_SECRET: process.env
		.JWT_REFRESH_TOKEN_SERVER_SECRET as string,
} as const
